/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router-dom'
import { getOrganization } from '../../services/Organizations/getOrganizations'
import { useOrganization } from './useOrganization'

export const useOrganizationList = () => {
  const location = useLocation()
  const { pathname } = location
  const pathnameArray = pathname.split('/')

  const [header, setHeader] = useState('')

  const [openModal, setOpenModal] = useState(false)
  const [openModal2, setOpenModal2] = useState(false)
  const [orgSelecionada, setOrgSelecionada] = useState(false)
  const [useOrganizationsList, setUseOrganizationList] =
    useState<GetOrganizationsType[]>()

  const [searchOrg, setSearchOrg] = useState('')

  const { doOrganization } = useOrganization(header)

  const mensagem = (): string => {
    if (pathnameArray.includes('organizacao')) {
      return 'Escolher organização'
    }
    return 'Trocar de organização'
  }

  const fetchUseOrganization = async () => {
    const result = await getOrganization()
    if ('message' in result) {
      if (result.message === 'cancelToken') {
        ;('')
      }
      if (result.message === 'Usuário não autenticado') {
        window.location.href = '/logout'
      } else {
        toast.error(result.message)
      }
    } else {
      setUseOrganizationList(result)
    }
  }

  const filteredOrganizations = useOrganizationsList?.filter(org =>
    org.nome.toLowerCase().includes(searchOrg.toLowerCase())
  )

  useEffect(() => {
    fetchUseOrganization()
  }, [])

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (openModal) {
      const timer = setTimeout(() => {
        doOrganization()
        setOpenModal2(!openModal2)
        setOpenModal(!openModal)
      }, 1500)
      return () => clearTimeout(timer)
    }
  }, [openModal])

  return {
    useOrganizationsList,
    fetchUseOrganization,
    header,
    setHeader,
    openModal,
    setOpenModal,
    openModal2,
    mensagem,
    setSearchOrg,
    filteredOrganizations,
    searchOrg,
    orgSelecionada,
    setOrgSelecionada,
  }
}
